module.exports = __webpack_public_path__ + "img/domonetizationClicks.145ea032.svg";